import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,
} from 'semantic-ui-react';
import { settingsActions } from '../../actions/settings.actions';
import 'react-quill/dist/quill.snow.css';

class IntegrationsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
        pontoTelSyncUserEmails: ''
    }
  }

  syncProtectedAccounts() {
    if (confirm('Sincronizar as contas protegidas do UserLock?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncAccounts());
    }
  }

  syncPontoTelUsers() {
    const { pontoTelSyncUserEmails } = this.state;
    if (!pontoTelSyncUserEmails) {
      alert('Preencha ao menos um e-mail');
      return;
    }

    if (confirm('Sincronizar o cadastro e registros de ponto dos usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncPontoTelUsers({ emails: pontoTelSyncUserEmails }));
    }
  }

  render() {  
    const { me } = this.props;
    const { pontoTelSyncUserEmails } = this.state;
    return (
      <Fragment>
        <Form>          
          {me?.permissions.includes('pontotel.sync') && <Fragment>
            <h3>Integração PontoTel</h3>          
            <Form.Input label='E-Mails Usuários a Sincronizar (separado por ,)' value={pontoTelSyncUserEmails} name='pontoTelSyncUserEmails' type='text' onChange={(e, data) => this.setState({"pontoTelSyncUserEmails": data.value} )} />

            <Button onClick={() => this.syncPontoTelUsers()} 
              type='button' 
              content='Sincronizar Usuários e Registros de Ponto'
              loading={this.props.loadingSync === 'pontoTelUsers'}
              icon='users' />          
          </Fragment>}

          {me?.permissions.includes('userlock.sync') && <Fragment>
            <h3>Integração UserLock</h3>          
            <Button onClick={() => this.syncProtectedAccounts()} 
              type='button' 
              content='Sincronizar Contas Protegidas'
              loading={this.props.loadingSync === 'accounts'}
              icon='users' />          
          </Fragment>}
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { settings, users } = state;
  return {
    settings: settings.globalSettings,
    loading: settings.loading || false,
    loadingSync: settings.loadingSync || false,
    me: users.me || null,
  };
}

const connectedconnectedPontoTelSyncScreen = connect(mapStateToProps)(IntegrationsScreen);
export { connectedconnectedPontoTelSyncScreen as IntegrationsScreen };
